/* 
  START: you can define custom functions within this area
  v v v v v v v v v v v v v v v v v v v v v v v v v v v
*/

function bindCookiePrefsClick() {
    var cookielink = document.querySelector('a[href="#CookiePreferences"]');
    if (cookielink) {
        cookielink.addEventListener('click', openCookiePrefs, false);
    }
}
function openCookiePrefs(e) {
    e.preventDefault();
    if (typeof OneTrust !== "undefined" && typeof OneTrust.ToggleInfoDisplay === "function") {
        OneTrust.ToggleInfoDisplay();
    } else {
        console.warn('OneTrust is not loaded yet.');
    }
    return false;
}

// Pass consent selections from OneTrust to Shopify
function listenForConsentUpdates() {
  window.addEventListener("OneTrustGroupsUpdated", otEvent => {
    var shopifyConsentGroups = {
      "analytics": otEvent.detail.includes('C0002'),
      "preferences": otEvent.detail.includes('C0003'),
      "marketing": otEvent.detail.includes('C0004'),
      "sale_of_data": otEvent.detail.includes('C0004')
    };
    window.Shopify.customerPrivacy.setTrackingConsent(shopifyConsentGroups, () => {
      var updatedConsent = window.Shopify.customerPrivacy.currentVisitorConsent(); 
      window.console.log('~~~~updated Shopify Consent', updatedConsent);
    });    
  });
}

/* PLP sticky filter bar */
function initPLPStickyNav() {
  var collectionNavBar = $('.navigation--root[data-sticky="true"]');
  let plpNavTop = collectionNavBar.offset().top;
  
  function plpstickynavbar() {
    //window.console.log('window.scrollY='+window.scrollY+' plpNavTop='+ plpNavTop);
    var annHeight = document.documentElement.style.getPropertyValue('--announcement-height').replace('px', '');
    var hdrHeight = document.documentElement.style.getPropertyValue('--header-height').replace('px', '');
    var scrollTrigger = (window.scrollY + parseInt(annHeight) + parseInt(hdrHeight));
    //window.console.log('scrollTrigger=', scrollTrigger);
    if (scrollTrigger >= plpNavTop) {    
      collectionNavBar.addClass('is-stuck');
    } else {
      collectionNavBar.removeClass('is-stuck');    
    }
  }
  plpstickynavbar();
  window.addEventListener('scroll', plpstickynavbar);
}
/* END: PLP sticky filter bar */

function accessibilityFixes() {
  $('body').on('keydown', 'a, [role="button"]', function(e) {
      if (e.key === ' ') {
        e.preventDefault(); // Prevent default spacebar behavior (scrolling)
        $(this).trigger('click'); // Trigger the button's click event
      }
  });
}

/* set up custom ElevarDataLayer events */
function bindCustomElevarEvents() {

  /** 
   * Optimove in GTM needs a "cart_empty" event
   * sent only when the cart goes from 1 or more to Zero
  */
  window.on('theme:cart:quantityUpdated', ({ detail: data }) => {
    if (data.items_removed && data.items_removed.length) {
      if (data.item_count == 0) {
        window.ElevarDataLayer.push({ event: "cart_empty" });
      }
    }
  });
}

function initTabs() {
  var tabsRoot = $('.tabs--root');
  if (tabsRoot.length) {
    tabsRoot.each((i,el)=>{
      var tabs = $(el).find('.tabs--menu-item');
      tabs.on( "click", function(e) {
        e.preventDefault();  
        var tab = $(this);
        tab.addClass('active-tab').siblings().removeClass('active-tab'); 
        var pnlId = tab.find('a').attr('href');
        var pnl = $(el).find(pnlId);
        pnl.addClass('active-panel').siblings().removeClass('active-panel');
        return false;
      });
    });
  }
}

function initTeamsModal() {
  var leaguesList = $('.leagues-with-icon--list');
  var teamsModal = $('.modal--root[data-id="teams"] .leagues-teams--container');
  if (leaguesList.length && teamsModal.length) {
      leaguesList.on('click', '.leagues-with-icon--link', function (e) {
        var modalTrigger = $(this);
        var handle = modalTrigger.data('handle');
        var activeTab = teamsModal.find('.tabs--menu-item[data-handle="'+handle+'"]');
        activeTab.trigger('click');
    });
  }
}

/** quickshop **/

(function () {
  if (window.__productTileMobileQuickshopInit) return;
  window.__productTileMobileQuickshopInit = true;

  const CARD_SELECTOR = 'product-tile-root[data-product-item]';
  const SWATCH_SELECTOR = '.radios--swatch-button';
  const SIZE_BTN_SELECTOR = '.product-card-size-hover__btn';
  const MOBILE_TRIGGER_SELECTOR = '.product-card-mobile-qs-trigger';
  const MOBILE_QS_CLOSE_SELECTOR = '[data-mobile-qs-close]';
  const GLOBAL_QS_SELECTOR = '#global-mobile-quickshop';

  const groupCache = new Map();

  function getCard(el) {
    return el.closest(CARD_SELECTOR);
  }

  function getGlobalQuickshop() {
    return document.querySelector(GLOBAL_QS_SELECTOR);
  }

  function openMobileQuickshop() {
    const qs = getGlobalQuickshop();
    if (!qs) return;

    qs.classList.add('is-open');
    qs.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mobile-qs-open');
    document.body.classList.add('mobile-qs-open');
  }

  function closeMobileQuickshop() {
    const qs = getGlobalQuickshop();
    if (!qs) return;

    qs.classList.remove('is-open');
    qs.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mobile-qs-open');
    document.body.classList.remove('mobile-qs-open');
  }

  async function fetchProduct(handle) {
    const response = await fetch(`/products/${handle}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Failed to fetch product: ${handle}`);
    return response.json();
  }

  async function getProduct(handle, masterSku) {
    let group = groupCache.get(masterSku);
    if (!group) {
      group = new Map();
      groupCache.set(masterSku, group);
    }
    if (!group.has(handle)) {
      const product = await fetchProduct(handle);
      group.set(handle, product);
    }
    return group.get(handle);
  }

  function getSizeOptionIndex(product) {
    if (!product?.options?.length) return -1;
    return product.options.findIndex(
      (name) => String(name).toLowerCase() === 'size'
    );
  }

  function getSizeLabel(variant, sizeIndex) {
    if (sizeIndex === 0) return variant.option1 || variant.title;
    if (sizeIndex === 1) return variant.option2 || variant.title;
    if (sizeIndex === 2) return variant.option3 || variant.title;
    const parts = String(variant.title || '').split(' / ');
    return parts[parts.length - 1] || variant.title;
  }

  function getCardPriceHTML(card) {
    const priceEl =
      card.querySelector('.js-tile-price') ||
      card.querySelector('.product--price-container');

    return priceEl ? priceEl.innerHTML : '';
  }

  function getCardImageData(card) {
    const img =
      card.querySelector('.product--image img') ||
      card.querySelector('.product--image-wrapper img');

    if (!img) {
      return { src: '', alt: '' };
    }

    return {
      src: img.currentSrc || img.src || '',
      alt: img.alt || ''
    };
  }

  function getCardTitle(card) {
    const el = card.querySelector('.product--title');
    return el ? el.textContent.trim() : '';
  }

  function getCardLink(card) {
    const link = card.querySelector('.product-tile--link[href]');
    return link ? link.href : '#';
  }

  function updateCardSizeButtons(card, product) {
    const sizeIndex = getSizeOptionIndex(product);
    const variants = product.variants || [];

    ['.product-card-size-hover__inner'].forEach((sel) => {
      const wrap = card.querySelector(sel);
      if (!wrap) return;

      wrap.innerHTML = '';

      variants.forEach((variant) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-card-size-hover__btn';
        btn.dataset.variantId = String(variant.id);
        btn.dataset.productHandle = product.handle;
        btn.textContent = getSizeLabel(variant, sizeIndex);
        btn.disabled = !variant.available;
        btn.classList.toggle('is-disabled', !variant.available);
        wrap.appendChild(btn);
      });
    });
  }

  function updateGlobalQuickshopGallery(product, fallbackCard) {
  const qs = getGlobalQuickshop();
  const gallery = qs?.querySelector('[data-quickshop-gallery]');
  const dotsWrap = qs?.querySelector('[data-quickshop-gallery-dots]');

  if (!qs || !gallery) return;

  let images = Array.isArray(product?.images)
    ? product.images.filter(Boolean)
    : [];

  if (!images.length && product?.featured_image) {
    images = [product.featured_image];
  }

  if (!images.length && fallbackCard) {
    const fallback = getCardImageData(fallbackCard);
    if (fallback.src) images = [fallback.src];
  }

  gallery.innerHTML = '';

  if (dotsWrap) {
    dotsWrap.innerHTML = '';
  }

  if (!images.length) return;

  images.forEach((src, index) => {
    const slide = document.createElement('div');
    slide.className = 'mini-product-gallery__slide';

    const img = document.createElement('img');
    img.className = 'mini-product-gallery__image';
    img.src = src;

    img.alt = product?.title
      ? `${product.title}${images.length > 1 ? ` image ${index + 1}` : ''}`
      : '';

    slide.appendChild(img);
    gallery.appendChild(slide);

    if (dotsWrap && images.length > 1) {
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'mini-product-gallery__dot';
      dot.setAttribute('aria-label', `Go to image ${index + 1}`);

      dot.addEventListener('click', () => {
        slide.scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      });

      dotsWrap.appendChild(dot);
    }
  });

  setupQuickshopGalleryDots(qs);

  requestAnimationFrame(() => {
    gallery.scrollLeft = 0;
    updateQuickshopGalleryDots(qs);
  });
}

function setupQuickshopGalleryDots(qs) {
  if (!qs || qs.__galleryDotsBound) return;

  qs.__galleryDotsBound = true;

  const gallery = qs.querySelector('[data-quickshop-gallery]');
  if (!gallery) return;

  function getSlides() {
    return [...gallery.querySelectorAll('.mini-product-gallery__slide')];
  }

  function getDots() {
    return [...qs.querySelectorAll('.mini-product-gallery__dot')];
  }

  function getCurrentIndex() {
    const slides = getSlides();

    if (!slides.length) return 0;

    const galleryLeft = gallery.getBoundingClientRect().left;

    let bestIndex = 0;
    let bestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(
        slide.getBoundingClientRect().left - galleryLeft
      );

      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });

    return bestIndex;
  }

  function updateDots() {
    const current = getCurrentIndex();

    getDots().forEach((dot, index) => {
      dot.classList.toggle('is-active', index === current);

      dot.setAttribute(
        'aria-current',
        index === current ? 'true' : 'false'
      );
    });
  }

  gallery.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateDots);
  });

  qs.__updateGalleryDots = updateDots;
}

function updateQuickshopGalleryDots(qs) {
  if (qs?.__updateGalleryDots) {
    qs.__updateGalleryDots();
  }
}

  function updateGlobalQuickshopTitle(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const title = qs?.querySelector('.mini-product-title');
    if (!title) return;

    const text = product?.title || (fallbackCard ? getCardTitle(fallbackCard) : '');
    title.textContent = text || '';
  }

  function updateGlobalQuickshopLink(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const link = qs?.querySelector('.mini-product-url');
    if (!link) return;

    if (product?.url) {
      link.href = product.url;
      return;
    }

    if (fallbackCard) {
      link.href = getCardLink(fallbackCard);
    }
  }

  function updateGlobalQuickshopPrice(card) {
    const qs = getGlobalQuickshop();
    const priceWrap = qs?.querySelector('.js-quickshop-price');
    if (!priceWrap || !card) return;

    priceWrap.innerHTML = getCardPriceHTML(card);
  }

  function updateGlobalQuickshopSizes(product) {
    const qs = getGlobalQuickshop();
    const wrap = qs?.querySelector('.variant-options');
    if (!wrap) return;

    const sizeIndex = getSizeOptionIndex(product);
    const variants = product.variants || [];
    const isOneSize = variants.length === 1;

    wrap.innerHTML = '';

    wrap.closest('.product-variants-container')?.classList.toggle('one-size', isOneSize);

    variants.forEach((variant) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-card-size-hover__btn single-variant-option';
      btn.dataset.variantId = String(variant.id);
      btn.dataset.productHandle = product.handle;

      btn.textContent = isOneSize ? 'Add to Cart' : getSizeLabel(variant, sizeIndex);

      if (isOneSize) {
        btn.classList.add('product-buy-buttons--primary');
      }

      btn.disabled = !variant.available;
      btn.classList.toggle('is-disabled', !variant.available);
      wrap.appendChild(btn);
    });
  }

  async function populateGlobalQuickshopFromCard(card) {
    const qs = getGlobalQuickshop();
    if (!qs || !card) return;

    const handle = card.dataset.productHandle;
    const masterSku = card.dataset.masterSku;

    qs.__sourceCard = card;
    qs.dataset.productHandle = handle || '';
    qs.dataset.masterSku = masterSku || '';

    updateGlobalQuickshopPrice(card);
    updateGlobalQuickshopTitle(null, card);
    updateGlobalQuickshopLink(null, card);
    updateGlobalQuickshopGallery(null, card);

    if (!handle || !masterSku) return;

    try {
      const product = await getProduct(handle, masterSku);
      updateGlobalQuickshopGallery(product, card);
      updateGlobalQuickshopTitle(product, card);
      updateGlobalQuickshopLink(product, card);
      updateGlobalQuickshopSizes(product);
      updateCardSizeButtons(card, product);
    } catch (e) {
      console.error('Failed to populate global quickshop:', e);
    }
  }

  async function onSwatchClick(swatch) {
    const card = getCard(swatch);
    if (!card) return;

    const handle = swatch.dataset.productHandle;
    const masterSku = card.dataset.masterSku;
    if (!handle || !masterSku) return;

    try {
      const product = await getProduct(handle, masterSku);

      card.dataset.productHandle = product.handle || handle;
      updateCardSizeButtons(card, product);

      const qs = getGlobalQuickshop();
      if (qs?.__sourceCard === card) {
        qs.dataset.productHandle = product.handle || handle;
        updateGlobalQuickshopGallery(product, card);
        updateGlobalQuickshopTitle(product, card);
        updateGlobalQuickshopLink(product, card);
        updateGlobalQuickshopSizes(product);

        requestAnimationFrame(() => updateGlobalQuickshopPrice(card));
        setTimeout(() => updateGlobalQuickshopPrice(card), 200);
      }
    } catch (e) {
      console.error('Failed to update quickshop content:', e);
    }
  }

  async function addVariantToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    if (btn.dataset.loading === 'true') return;

    btn.dataset.loading = 'true';

    try {
      await theme.cart.addItem({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }, variantId);

      closeMobileQuickshop();
      theme.drawer.open('right', 'cart-drawer', btn);
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      delete btn.dataset.loading;
    }
  }

 document.addEventListener('click', async function (e) {
  const trigger = e.target.closest(MOBILE_TRIGGER_SELECTOR);
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const card = getCard(trigger);
    if (!card) return;

    await populateGlobalQuickshopFromCard(card);
    openMobileQuickshop();
    return;
  }

  const close = e.target.closest(MOBILE_QS_CLOSE_SELECTOR);
  if (close) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    closeMobileQuickshop();
    return;
  }

  const sizeBtn = e.target.closest(SIZE_BTN_SELECTOR);
  if (sizeBtn) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    addVariantToCart(sizeBtn);
    return;
  }

  const swatch = e.target.closest(SWATCH_SELECTOR);
  if (swatch) {
    onSwatchClick(swatch);
  }
}, true);
})(); 

/** hide klaviyo pop up when quickshop is open **/

function hideKlaviyoWhenQuickshopOpen() {
  const quickshop = document.getElementById('global-mobile-quickshop');
  if (!quickshop) return;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function isQuickshopOpen() {
    return (
      isMobile() &&
      (
        quickshop.classList.contains('is-open') ||
        quickshop.getAttribute('aria-hidden') === 'false'
      )
    );
  }

  function updateState() {
    if (isQuickshopOpen()) {
      document.documentElement.setAttribute('data-quickshop-open', 'true');
    } else {
      document.documentElement.removeAttribute('data-quickshop-open');
    }
  }

  new MutationObserver(updateState).observe(quickshop, {
    attributes: true,
    attributeFilter: ['class', 'aria-hidden'],
  });

  window.addEventListener('resize', updateState);
  updateState();
}

/** quickshop **/

(function () {
  if (window.__productTileMobileQuickshopInit) return;
  window.__productTileMobileQuickshopInit = true;

  const CARD_SELECTOR = 'product-tile-root[data-product-item]';
  const SWATCH_SELECTOR = '.radios--swatch-button';
  const SIZE_BTN_SELECTOR = '.product-card-size-hover__btn';
  const MOBILE_TRIGGER_SELECTOR = '.product-card-mobile-qs-trigger';
  const MOBILE_QS_CLOSE_SELECTOR = '[data-mobile-qs-close]';
  const GLOBAL_QS_SELECTOR = '#global-mobile-quickshop';

  const groupCache = new Map();

  function getCard(el) {
    return el.closest(CARD_SELECTOR);
  }

  function getGlobalQuickshop() {
    return document.querySelector(GLOBAL_QS_SELECTOR);
  }

  function openMobileQuickshop() {
    const qs = getGlobalQuickshop();
    if (!qs) return;

    qs.classList.add('is-open');
    qs.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mobile-qs-open');
    document.body.classList.add('mobile-qs-open');
  }

  function closeMobileQuickshop() {
    const qs = getGlobalQuickshop();
    if (!qs) return;

    qs.classList.remove('is-open');
    qs.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mobile-qs-open');
    document.body.classList.remove('mobile-qs-open');
  }

  async function fetchProduct(handle) {
    const response = await fetch(`/products/${handle}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Failed to fetch product: ${handle}`);
    return response.json();
  }

  async function getProduct(handle, masterSku) {
    let group = groupCache.get(masterSku);
    if (!group) {
      group = new Map();
      groupCache.set(masterSku, group);
    }
    if (!group.has(handle)) {
      const product = await fetchProduct(handle);
      group.set(handle, product);
    }
    return group.get(handle);
  }

  function getSizeOptionIndex(product) {
    if (!product?.options?.length) return -1;
    return product.options.findIndex(
      (name) => String(name).toLowerCase() === 'size'
    );
  }

  function getSizeLabel(variant, sizeIndex) {
    if (sizeIndex === 0) return variant.option1 || variant.title;
    if (sizeIndex === 1) return variant.option2 || variant.title;
    if (sizeIndex === 2) return variant.option3 || variant.title;
    const parts = String(variant.title || '').split(' / ');
    return parts[parts.length - 1] || variant.title;
  }

  function getCardPriceHTML(card) {
    const priceEl =
      card.querySelector('.js-tile-price') ||
      card.querySelector('.product--price-container');

    return priceEl ? priceEl.innerHTML : '';
  }

  function getCardImageData(card) {
    const img =
      card.querySelector('.product--image img') ||
      card.querySelector('.product--image-wrapper img');

    if (!img) {
      return { src: '', alt: '' };
    }

    return {
      src: img.currentSrc || img.src || '',
      alt: img.alt || ''
    };
  }

  function getCardTitle(card) {
    const el = card.querySelector('.product--title');
    return el ? el.textContent.trim() : '';
  }

  function getCardLink(card) {
    const link = card.querySelector('.product-tile--link[href]');
    return link ? link.href : '#';
  }

  function updateCardSizeButtons(card, product) {
    const sizeIndex = getSizeOptionIndex(product);
    const variants = product.variants || [];

    ['.product-card-size-hover__inner'].forEach((sel) => {
      const wrap = card.querySelector(sel);
      if (!wrap) return;

      wrap.innerHTML = '';

      variants.forEach((variant) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-card-size-hover__btn';
        btn.dataset.variantId = String(variant.id);
        btn.dataset.productHandle = product.handle;
        btn.textContent = getSizeLabel(variant, sizeIndex);
        btn.disabled = !variant.available;
        btn.classList.toggle('is-disabled', !variant.available);
        wrap.appendChild(btn);
      });
    });
  }

  function updateGlobalQuickshopGallery(product, fallbackCard) {
  const qs = getGlobalQuickshop();
  const gallery = qs?.querySelector('[data-quickshop-gallery]');
  const dotsWrap = qs?.querySelector('[data-quickshop-gallery-dots]');

  if (!qs || !gallery) return;

  let images = Array.isArray(product?.images)
    ? product.images.filter(Boolean)
    : [];

  if (!images.length && product?.featured_image) {
    images = [product.featured_image];
  }

  if (!images.length && fallbackCard) {
    const fallback = getCardImageData(fallbackCard);
    if (fallback.src) images = [fallback.src];
  }

  gallery.innerHTML = '';

  if (dotsWrap) {
    dotsWrap.innerHTML = '';
  }

  if (!images.length) return;

  images.forEach((src, index) => {
    const slide = document.createElement('div');
    slide.className = 'mini-product-gallery__slide';

    const img = document.createElement('img');
    img.className = 'mini-product-gallery__image';
    img.src = src;

    img.alt = product?.title
      ? `${product.title}${images.length > 1 ? ` image ${index + 1}` : ''}`
      : '';

    slide.appendChild(img);
    gallery.appendChild(slide);

    if (dotsWrap && images.length > 1) {
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'mini-product-gallery__dot';
      dot.setAttribute('aria-label', `Go to image ${index + 1}`);

      dot.addEventListener('click', () => {
        slide.scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      });

      dotsWrap.appendChild(dot);
    }
  });

  setupQuickshopGalleryDots(qs);

  requestAnimationFrame(() => {
    gallery.scrollLeft = 0;
    updateQuickshopGalleryDots(qs);
  });
}

function setupQuickshopGalleryDots(qs) {
  if (!qs || qs.__galleryDotsBound) return;

  qs.__galleryDotsBound = true;

  const gallery = qs.querySelector('[data-quickshop-gallery]');
  if (!gallery) return;

  function getSlides() {
    return [...gallery.querySelectorAll('.mini-product-gallery__slide')];
  }

  function getDots() {
    return [...qs.querySelectorAll('.mini-product-gallery__dot')];
  }

  function getCurrentIndex() {
    const slides = getSlides();

    if (!slides.length) return 0;

    const galleryLeft = gallery.getBoundingClientRect().left;

    let bestIndex = 0;
    let bestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(
        slide.getBoundingClientRect().left - galleryLeft
      );

      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });

    return bestIndex;
  }

  function updateDots() {
    const current = getCurrentIndex();

    getDots().forEach((dot, index) => {
      dot.classList.toggle('is-active', index === current);

      dot.setAttribute(
        'aria-current',
        index === current ? 'true' : 'false'
      );
    });
  }

  gallery.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateDots);
  });

  qs.__updateGalleryDots = updateDots;
}

function updateQuickshopGalleryDots(qs) {
  if (qs?.__updateGalleryDots) {
    qs.__updateGalleryDots();
  }
}

  function updateGlobalQuickshopTitle(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const title = qs?.querySelector('.mini-product-title');
    if (!title) return;

    const text = product?.title || (fallbackCard ? getCardTitle(fallbackCard) : '');
    title.textContent = text || '';
  }

  function updateGlobalQuickshopLink(product, fallbackCard) {
    const qs = getGlobalQuickshop();
    const link = qs?.querySelector('.mini-product-url');
    if (!link) return;

    if (product?.url) {
      link.href = product.url;
      return;
    }

    if (fallbackCard) {
      link.href = getCardLink(fallbackCard);
    }
  }

  function updateGlobalQuickshopPrice(card) {
    const qs = getGlobalQuickshop();
    const priceWrap = qs?.querySelector('.js-quickshop-price');
    if (!priceWrap || !card) return;

    priceWrap.innerHTML = getCardPriceHTML(card);
  }

  function updateGlobalQuickshopSizes(product) {
    const qs = getGlobalQuickshop();
    const wrap = qs?.querySelector('.variant-options');
    if (!wrap) return;

    const sizeIndex = getSizeOptionIndex(product);
    const variants = product.variants || [];
    const isOneSize = variants.length === 1;

    wrap.innerHTML = '';

    wrap.closest('.product-variants-container')?.classList.toggle('one-size', isOneSize);

    variants.forEach((variant) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-card-size-hover__btn single-variant-option';
      btn.dataset.variantId = String(variant.id);
      btn.dataset.productHandle = product.handle;

      btn.textContent = isOneSize ? 'Add to Cart' : getSizeLabel(variant, sizeIndex);

      if (isOneSize) {
        btn.classList.add('product-buy-buttons--primary');
      }

      btn.disabled = !variant.available;
      btn.classList.toggle('is-disabled', !variant.available);
      wrap.appendChild(btn);
    });
  }

  async function populateGlobalQuickshopFromCard(card) {
    const qs = getGlobalQuickshop();
    if (!qs || !card) return;

    const handle = card.dataset.productHandle;
    const masterSku = card.dataset.masterSku;

    qs.__sourceCard = card;
    qs.dataset.productHandle = handle || '';
    qs.dataset.masterSku = masterSku || '';

    updateGlobalQuickshopPrice(card);
    updateGlobalQuickshopTitle(null, card);
    updateGlobalQuickshopLink(null, card);
    updateGlobalQuickshopGallery(null, card);

    if (!handle || !masterSku) return;

    try {
      const product = await getProduct(handle, masterSku);
      updateGlobalQuickshopGallery(product, card);
      updateGlobalQuickshopTitle(product, card);
      updateGlobalQuickshopLink(product, card);
      updateGlobalQuickshopSizes(product);
      updateCardSizeButtons(card, product);
    } catch (e) {
      console.error('Failed to populate global quickshop:', e);
    }
  }

  async function onSwatchClick(swatch) {
    const card = getCard(swatch);
    if (!card) return;

    const handle = swatch.dataset.productHandle;
    const masterSku = card.dataset.masterSku;
    if (!handle || !masterSku) return;

    try {
      const product = await getProduct(handle, masterSku);

      card.dataset.productHandle = product.handle || handle;
      updateCardSizeButtons(card, product);

      const qs = getGlobalQuickshop();
      if (qs?.__sourceCard === card) {
        qs.dataset.productHandle = product.handle || handle;
        updateGlobalQuickshopGallery(product, card);
        updateGlobalQuickshopTitle(product, card);
        updateGlobalQuickshopLink(product, card);
        updateGlobalQuickshopSizes(product);

        requestAnimationFrame(() => updateGlobalQuickshopPrice(card));
        setTimeout(() => updateGlobalQuickshopPrice(card), 200);
      }
    } catch (e) {
      console.error('Failed to update quickshop content:', e);
    }
  }

  async function addVariantToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    if (btn.dataset.loading === 'true') return;

    btn.dataset.loading = 'true';

    try {
      await theme.cart.addItem({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }, variantId);

      closeMobileQuickshop();
      theme.drawer.open('right', 'cart-drawer', btn);
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      delete btn.dataset.loading;
    }
  }

 document.addEventListener('click', async function (e) {
  const trigger = e.target.closest(MOBILE_TRIGGER_SELECTOR);
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const card = getCard(trigger);
    if (!card) return;

    await populateGlobalQuickshopFromCard(card);
    openMobileQuickshop();
    return;
  }

  const close = e.target.closest(MOBILE_QS_CLOSE_SELECTOR);
  if (close) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    closeMobileQuickshop();
    return;
  }

  const sizeBtn = e.target.closest(SIZE_BTN_SELECTOR);
  if (sizeBtn) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    addVariantToCart(sizeBtn);
    return;
  }

  const swatch = e.target.closest(SWATCH_SELECTOR);
  if (swatch) {
    onSwatchClick(swatch);
  }
}, true);
})(); 

/** hide klaviyo pop up when quickshop is open **/

function hideKlaviyoWhenQuickshopOpen() {
  const quickshop = document.getElementById('global-mobile-quickshop');
  if (!quickshop) return;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function isQuickshopOpen() {
    return (
      isMobile() &&
      (
        quickshop.classList.contains('is-open') ||
        quickshop.getAttribute('aria-hidden') === 'false'
      )
    );
  }

  function updateState() {
    if (isQuickshopOpen()) {
      document.documentElement.setAttribute('data-quickshop-open', 'true');
    } else {
      document.documentElement.removeAttribute('data-quickshop-open');
    }
  }

  new MutationObserver(updateState).observe(quickshop, {
    attributes: true,
    attributeFilter: ['class', 'aria-hidden'],
  });

  window.addEventListener('resize', updateState);
  updateState();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideKlaviyoWhenQuickshopOpen);
} else {
  hideKlaviyoWhenQuickshopOpen();
}


/* 
  ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
  END: area to define custom functions
  =====================================================
*/


/* 
  jQueryIsReady is just like like $(document).ready() - put your jQuery code here to avoid timing errors
*/
var jQueryIsReady = function() {
  /* 
    START: add any jQuery code or call functions that DEPEND on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */

  accessibilityFixes();
  initTabs();
  initTeamsModal();
  
  if ( $('.navigation--root[data-sticky="true"]').length ) {
     initPLPStickyNav();
  }

  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: code that DEPENDS on jQuery goes in the area above
  */
} 
// end jQueryIsReady
// ========================================================================


/* 
  dkCustomInit is a function that runs immediately on page load, 
  but may finish before jQuery is fully loaded
*/
function dkCustomInit() {
  var checkJquery = function(){
    if (typeof jQuery === "undefined"){
        return false;
    } else {
        clearTimeout(jqInterval);
        jQueryIsReady();
    }
  }
  var jqInterval = setInterval(checkJquery,1000);

  /* 
    START: call any functions that DON'T depend on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */


  // Pass consent selections from OneTrust to Shopify
  listenForConsentUpdates();

  bindCookiePrefsClick();
  bindCustomElevarEvents();

  openYotpoReviewModalFromQueryParam();
  
  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: functions that DON'T depend on jQuery
    =====================================================
  */ 
}
// end dkCustomInit
// ========================================================================


/* LEAVE THIS AT THE BOTTOM OF THE FILE AND DO NOT EDIT */
if (/complete|interactive|loaded/.test(document.readyState)) {
    dkCustomInit();
} else {
    document.addEventListener('DOMContentLoaded', dkCustomInit);
};